(() => {
  let ticking = false;

  const clamp = (value, min = 0, max = 1) => {
    return Math.max(min, Math.min(max, value));
  };

  const updateIntro = (landing) => {
    const introWrap = landing.querySelector('[data-sq-intro-wrap]');

    if (!introWrap) return;

    const rect = introWrap.getBoundingClientRect();
    const total = introWrap.offsetHeight - window.innerHeight;

    if (total <= 0) {
      landing.style.setProperty('--sq-progress', '0');
      return;
    }

    const passed = -rect.top;
    const progress = clamp(passed / total);

    landing.style.setProperty(
      '--sq-progress',
      progress.toFixed(4)
    );
  };

  const updateMotion = (element) => {
    const rect = element.getBoundingClientRect();
    const viewport = window.innerHeight;

    const rawProgress =
      (viewport - rect.top) /
      (viewport + rect.height);

    const progress = clamp(rawProgress);

    const reveal = clamp(
      (progress - 0.08) / 0.38
    );

    const remaining = 1 - reveal;

    const mobileFactor =
      window.innerWidth <= 768
        ? 0.55
        : 1;

    let x = 0;
    let y = 0;
    let scale = 1;
    let rotate = 0;

    const hasEffect = (effect) => {
 return (
  element.classList.contains(
    `sq-system__media--${effect}`
  ) ||
  element.classList.contains(
    `sq-hero__media--${effect}`
  ) ||
  element.classList.contains(
    `sq-range__media--${effect}`
  )
);
};

if (hasEffect('zoom')) {
  scale =
    0.78 +
    (reveal * 0.22) +
    (progress * 0.04);
}

if (hasEffect('slide-left')) {
  x =
    -140 *
    remaining *
    mobileFactor;
}

if (hasEffect('slide-right')) {
  x =
    140 *
    remaining *
    mobileFactor;
}

if (hasEffect('float')) {
  y =
    (
      60 * remaining -
      progress * 30
    ) *
    mobileFactor;

  scale =
    0.94 +
    (reveal * 0.06);
}

if (hasEffect('rotate')) {
  y =
    45 *
    remaining *
    mobileFactor;

  rotate =
    -9 *
    remaining *
    mobileFactor;

  scale =
    0.9 +
    (reveal * 0.1);
}

    const opacity =
      0.15 +
      (reveal * 0.85);

    element.style.setProperty(
      '--sq-x',
      `${x.toFixed(2)}px`
    );

    element.style.setProperty(
      '--sq-y',
      `${y.toFixed(2)}px`
    );

    element.style.setProperty(
      '--sq-scale',
      scale.toFixed(4)
    );

    element.style.setProperty(
      '--sq-rotate',
      `${rotate.toFixed(2)}deg`
    );

    element.style.setProperty(
      '--sq-opacity',
      opacity.toFixed(3)
    );
  };

  const updateAll = () => {
    const landings =
      document.querySelectorAll(
        '[data-sq-landing]'
      );

    landings.forEach((landing) => {
      updateIntro(landing);

      const motionElements =
        landing.querySelectorAll(
          '[data-sq-motion]'
        );

      motionElements.forEach(
        updateMotion
      );
    });

    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(updateAll);
  };

  const init = () => {
    requestUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  window.addEventListener(
    'scroll',
    requestUpdate,
    {
      passive: true
    }
  );

  window.addEventListener(
    'resize',
    requestUpdate
  );

  document.addEventListener(
    'shopify:section:load',
    () => {
      requestAnimationFrame(
        requestUpdate
      );
    }
  );

  document.addEventListener(
    'shopify:section:select',
    () => {
      requestAnimationFrame(
        requestUpdate
      );
    }
  );
})();